import type { BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { ContentContainer } from '../ContentContainer/ContentContainer';
import { ContentWrapper } from '../ContentWrapper/ContentWrapper';

export const SectionContainer = ({
	children,
	...props
}: PropsWithChildren<BoxProps>) => {
	return (
		<ContentContainer>
			<ContentWrapper {...props}>
				{children}
			</ContentWrapper>
		</ContentContainer>
	);
};
